































































import { DialogForm } from '@/components/bwaff';
import {Component, Prop} from 'vue-property-decorator';
import Form from '@/components/form-base';
import {mixins} from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';
import IntegrationMixin from '@/views/settings/integrations/custom-integrations/mixins/integration-mixin';

@Component({
  components: {
    DialogForm,
  }
})
export default class ChooseIntegrationDialog extends mixins<Form,IntegrationMixin,PlanLimitsMixin>(Form,IntegrationMixin,PlanLimitsMixin) {
  @Prop({ default: {} })
  data: any;

  search: string = '';
  selectedIntegration: any = '';

  get integrationsListFiltered() {
    if(!this.search) return this.integrationsData;
    return Object.values(this.integrationsData).filter((item:any)=>item.name.toLowerCase().includes(this.search.toLowerCase()))
  }

  close() {
    this.$emit('close');
  }

  selectIntegration(obj:any) {
    const planLimits = this.integrationsPlanLimits(obj.type)
    if(this.hasPlanLimitsRestriction(planLimits)){
      return this.handleClickPlanLimits(planLimits)
    }
    this.selectedIntegration = obj;
  }

  create() {
    const { createIntegrationOpen } = this.data
    this.close()
    createIntegrationOpen({
      type:this.selectedIntegration.type
    })
  }

}
